(function () {
  // ── Category toggles ──────────────────────────────────────────
  document.querySelectorAll('.faqs-tiered__cat-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      const body = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', !expanded);
      if (body) body.setAttribute('aria-hidden', expanded);
    });
  });

  // ── Individual Q&A accordions (scoped to tiered container) ───
  // Uses same aria pattern as existing section-faqs.js but scoped
  // so the two don't interfere if both sections appear on a page.
  document.querySelectorAll('.faqs-tiered__cat-body .accordion-heading').forEach(btn => {
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', !expanded);
      const panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) panel.setAttribute('aria-hidden', expanded);
    });
  });
})();
